// extracted by mini-css-extract-plugin
export default {"_":"MetaIcons____1TQrJ"};